var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSongwriting = function SvgSongwriting(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M5.524 12.819v2.145a2.26 2.26 0 0 1-1.685 2.187l-.48.127a1.88 1.88 0 1 1-.958-3.636zm0 0V4.224L15 1.69V7.5m-9.476-.276L15 4.69m3.59 3.895a1.996 1.996 0 1 1 2.825 2.824l-9.532 9.532L8 22l1.06-3.883z"
  })));
};
export default SvgSongwriting;